export class SupportList {
  constructor (elem) {
    this.elem = elem
    this.toggles = elem.querySelectorAll('[data-support-list-toggle]')
    this.list = elem.querySelector('[data-support-list-ul]')

    if (this.toggles === null) {
      return
    }

    this.toggles.forEach(element => {
      element.addEventListener('click', (e) => {
        this.toggleList(e.target)
      })
    })
  }

  toggleList (elem) {
    this.toggles.forEach(element => {
      element.classList.remove('s-list__link--hide')
    })
    elem.classList.add('s-list__link--hide')
    this.list.classList.toggle('s-list__ul--open')
  }
}

export function setupSupportLists (document) {
  const elems = document.querySelectorAll('[data-support-list]')
  const supportLists = []

  for (const element of elems) {
    supportLists.push(new SupportList(element))
  }

  return supportLists
}
